/* Örün teması */
document.documentElement.classList.add("js");
const $ = (s, k = document) => k.querySelector(s);
const $$ = (s, k = document) => [...k.querySelectorAll(s)];
const T = window.tema || {};

/* Shopify para biçimi: "{{amount_with_comma_separator}} ₺" gibi */
function para(kurus) {
  const bicim = T.paraBicimi || "{{amount}} ₺";
  const yaz = (sayi, ondalik, binlik, ayirac) => {
    const [tam, kesir] = (sayi / 100).toFixed(ondalik).split(".");
    return tam.replace(/\B(?=(\d{3})+(?!\d))/g, binlik) + (kesir ? ayirac + kesir : "");
  };
  return bicim.replace(/\{\{\s*(\w+)\s*\}\}/, (_, tur) => ({
    amount: yaz(kurus, 2, ",", "."),
    amount_no_decimals: yaz(kurus, 0, ",", "."),
    amount_with_comma_separator: yaz(kurus, 2, ".", ","),
    amount_no_decimals_with_comma_separator: yaz(kurus, 0, ".", ","),
    amount_with_apostrophe_separator: yaz(kurus, 2, "'", "."),
  }[tur] ?? yaz(kurus, 2, ",", ".")));
}
const yuzde = n => "%" + n;

/* Aynı gün kargo sayacı (İstanbul saatiyle) */
function kargoDurumu() {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Istanbul", weekday: "short", hour: "numeric", minute: "numeric", hourCycle: "h23" })
    .formatToParts(new Date()).map(x => [x.type, x.value]));
  const sinir = (T.kesimSaati || 16) * 60, dk = +p.hour * 60 + +p.minute, gun = p.weekday;
  const kargoGunu = gun !== "Sun" && (gun !== "Sat" || T.cumartesiKargo);
  if (kargoGunu && dk < sinir) {
    const kalan = sinir - dk, s = Math.floor(kalan / 60), d = kalan % 60;
    return { bugun: true, kisa: "Bugün kargoda", uzun: `${s ? s + " sa " : ""}${d} dk kaldı` };
  }
  const gunler = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], adlar = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
  let i = gunler.indexOf(gun), fark = 0;
  do { i = (i + 1) % 7; fark++; } while (i === 0 || (i === 6 && !T.cumartesiKargo));
  const ertesi = fark === 1 ? "Yarın" : adlar[i];
  return { bugun: false, kisa: `${ertesi} kargoda`, uzun: "" };
}
function sayaclariYaz() {
  const k = kargoDurumu();
  $$("[data-sayac]").forEach(el => {
    el.classList.toggle("gec", !k.bugun);
    $("b", el).textContent = k.kisa;
    $("span", el).textContent = k.uzun;
  });
  $$("[data-sayac-yazi]").forEach(el => {
    if (!el.dataset.ilk) el.dataset.ilk = el.textContent;
    el.textContent = k.bugun ? `Bugün kargoda: ${k.uzun}, hemen sipariş verin.` : `${k.kisa}. ${el.dataset.ilk}`;
  });
}
sayaclariYaz();
setInterval(sayaclariYaz, 30000);

/* Çerez bildirimi: kabul bir kez sorulur */
{
  const kutu = $("[data-cerez]");
  if (kutu) {
    let kabul = false;
    try { kabul = localStorage.getItem("orun-cerez") === "1"; } catch (e) {}
    if (!kabul) kutu.hidden = false;
    $("[data-cerez-kabul]", kutu).addEventListener("click", () => {
      try { localStorage.setItem("orun-cerez", "1"); } catch (e) {}
      window.Shopify?.customerPrivacy?.setTrackingConsent?.({ analytics: true, marketing: true, preferences: true, sale_of_data: true }, () => {});
      kutu.hidden = true;
    });
  }
}

/* Mobil menü */
{
  const mm = $(".mobil-menu"), ac = $(".menu-ac");
  if (mm && ac) {
    const kapa = () => { mm.classList.remove("acik"); ac.setAttribute("aria-expanded", "false"); document.body.style.overflow = ""; };
    ac.addEventListener("click", () => { mm.classList.add("acik"); ac.setAttribute("aria-expanded", "true"); document.body.style.overflow = "hidden"; });
    $(".kapat", mm).addEventListener("click", kapa);
    $$("a", mm).forEach(a => a.addEventListener("click", kapa));
    document.addEventListener("keydown", e => e.key === "Escape" && kapa());
  }
}

/* Arama katmanı ve yazarken açılan ürün önerileri */
{
  const katman = $("[data-arama]");
  if (katman) {
    const girdi = $("input[type=search]", katman), sonuc = $("[data-arama-sonuc]", katman);
    const kapa = () => { katman.hidden = true; };
    $$("[data-arama-ac]").forEach(b => b.addEventListener("click", () => { katman.hidden = false; girdi.focus(); }));
    $("[data-arama-kapat]", katman).addEventListener("click", kapa);
    document.addEventListener("keydown", e => e.key === "Escape" && kapa());

    let sayac, istek;
    girdi.addEventListener("input", () => {
      clearTimeout(sayac);
      const q = girdi.value.trim();
      if (q.length < 2) { istek?.abort(); sonuc.hidden = true; sonuc.innerHTML = ""; return; }
      sayac = setTimeout(async () => {
        istek?.abort();
        istek = new AbortController();
        const adres = `${T.oneriUrl || "/search/suggest"}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=arama-onerileri`;
        try {
          const html = await fetch(adres, { signal: istek.signal }).then(r => r.text());
          const oneriler = $("[data-oneriler]", new DOMParser().parseFromString(html, "text/html"));
          sonuc.replaceChildren(...(oneriler ? [oneriler] : []));
          sonuc.hidden = !oneriler;
        } catch (e) {}
      }, 200);
    });
  }
}

/* Bildirim ve sepet */
function bildir(metin, link) {
  const b = $(".bildirim");
  if (!b) return;
  b.innerHTML = '<svg aria-hidden="true"><use href="#tik"/></svg><span></span>';
  b.lastChild.textContent = metin;
  if (link) { const a = document.createElement("a"); a.href = T.sepetUrl; a.textContent = "Sepete git"; b.append(a); }
  b.hidden = false;
  requestAnimationFrame(() => b.classList.add("acik"));
  clearTimeout(bildir.t);
  bildir.t = setTimeout(() => { b.classList.remove("acik"); setTimeout(() => (b.hidden = true), 400); }, 4000);
}
async function sepetSayisiniYenile() {
  const c = await fetch("/cart.js").then(r => r.json());
  $$("[data-sepet-sayi]").forEach(e => { e.textContent = c.item_count; e.hidden = !c.item_count; });
}
async function sepeteEkle(kalemler) {
  const r = await fetch(T.sepetEkleUrl + ".js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items: kalemler }),
  });
  const veri = await r.json();
  if (!r.ok) throw new Error(veri.description || veri.message || "Sepete eklenemedi");
  await sepetSayisiniYenile();
  return veri;
}

/* +/- miktar düğmeleri (ürün ve sepet) */
document.addEventListener("click", e => {
  const b = e.target.closest("[data-miktar]");
  if (!b) return;
  const input = $("input", b.parentElement);
  const yeni = Math.max(+input.min || 0, (+input.value || 0) + +b.dataset.miktar);
  if (yeni === +input.value) return;
  input.value = yeni;
  input.dispatchEvent(new Event("change", { bubbles: true }));
});

/* Değişince formu gönder: sıralama, filtre kutuları, sepet adedi */
document.addEventListener("change", e => {
  const el = e.target;
  if (el.matches("[data-otomatik-gonder]") || el.closest("[data-filtre-form]") && el.type === "checkbox") {
    clearTimeout(el._t);
    el._t = setTimeout(() => el.form.requestSubmit ? el.form.requestSubmit() : el.form.submit(), el.type === "number" ? 500 : 0);
  }
});
/* Filtre formu: boş alanları adrese koyma */
$$("[data-filtre-form]").forEach(f => f.addEventListener("submit", e => {
  e.preventDefault();
  const p = new URLSearchParams();
  for (const [k, v] of new FormData(f)) if (v !== "") p.append(k, v);
  location.search = p.toString();
}));

/* Kesim masası */
$$("[data-kesim]").forEach(kok => {
  const kutular = $$(".kutu", kok), kartlar = $$("[data-kutu-kart]", kok);
  kutular.forEach(b => b.addEventListener("click", () => {
    kutular.forEach(x => { x.classList.toggle("secili", x === b); x.setAttribute("aria-pressed", x === b); });
    kartlar.forEach(k => (k.hidden = k.dataset.kutuKart !== b.dataset.kutu));
  }));
});

/* Renk kartelası */
$$("[data-kartela]").forEach(kok => {
  const img = $("[data-renk-img]", kok), ad = $("[data-renk-ad]", kok), fiyat = $("[data-renk-fiyat]", kok), link = $("[data-renk-link]", kok);
  const seritler = $$(".serit-kart", kok);
  seritler.forEach(b => b.addEventListener("click", () => {
    seritler.forEach(x => { x.classList.toggle("secili", x === b); x.setAttribute("aria-pressed", x === b); });
    ad.textContent = b.dataset.renk;
    fiyat.textContent = b.dataset.fiyat;
    if (link) link.href = b.dataset.url;
    if (img && b.dataset.gorsel) {
      img.style.opacity = 0;
      setTimeout(() => { img.srcset = ""; img.src = b.dataset.gorsel; img.alt = b.dataset.renk + " takı kutusu"; img.style.opacity = 1; }, 180);
    }
  }));
});

/* Etiket yaprağı süzgeci */
$$("[data-etiketler]").forEach(kok => {
  const dugmeler = $$(".filtre button", kok);
  dugmeler.forEach(b => b.addEventListener("click", () => {
    dugmeler.forEach(x => { x.classList.toggle("secili", x === b); x.setAttribute("aria-pressed", x === b); });
    $$(".etiket", kok).forEach(e => e.classList.toggle("soluk", b.dataset.tur !== "hepsi" && e.dataset.tur !== b.dataset.tur));
  }));
});

/* Özel baskı talebi → WhatsApp */
$$("[data-talep]").forEach(f => f.addEventListener("submit", e => {
  e.preventDefault();
  const v = new FormData(f);
  const metin = `Merhaba, firma özel baskı için teklif almak istiyorum.\nÜrün: ${v.get("urun")}\nAdet: ${v.get("adet")}${v.get("not") ? "\nNot: " + v.get("not") : ""}`;
  window.open(`https://wa.me/${T.whatsapp}?text=${encodeURIComponent(metin)}`, "_blank", "noopener");
}));

/* ÜRÜN SAYFASI */
$$("[data-urun]").forEach(kok => {
  const { varyantlar } = JSON.parse($("[data-urun-veri]", kok).textContent);
  const form = $("[data-urun-form]", kok), idInput = $("[data-varyant-id]", kok), ekle = $("[data-ekle]", kok);
  const radyolar = $$("[data-secenek]", kok);
  const adetInput = $("input[name=quantity]", kok);
  const secenekSayisi = varyantlar[0]?.secenekler.length || 0;

  const seciliDegerler = () => Array.from({ length: secenekSayisi }, (_, i) => $(`[data-secenek="${i}"]:checked`, kok)?.value);
  const bul = degerler => varyantlar.find(v => v.secenekler.every((d, i) => d === degerler[i]));
  let varyant = varyantlar.find(v => v.id === +idInput.value) || varyantlar[0];

  /* Adet başı fiyatın tabanı: aynı seçeneklerdeki en küçük paket */
  const birim = v => (v.adet ? v.fiyat / v.adet : 0);

  const kucukler = $$(".kucukler button", kok);
  const anaDugme = $("[data-buyut]", kok), anaFoto = anaDugme && $("img", anaDugme);
  function fotoGoster(medyaId) {
    const k = $(`.kucukler [data-medya="${medyaId}"]`, kok);
    if (!k || !anaFoto) return;
    kucukler.forEach(b => b.classList.toggle("secili", b === k));
    anaFoto.removeAttribute("srcset"); anaFoto.src = k.dataset.buyuk;
    anaDugme.dataset.tam = k.dataset.tam;
  }
  kucukler.forEach(b => b.addEventListener("click", () => fotoGoster(b.dataset.medya)));

  /* Ana fotoğrafa basınca tam ekran; oklar ve klavye ile gezinme */
  const bf = $("[data-buyuk-foto]", kok);
  if (anaDugme && bf) {
    const bfFoto = $("img", bf);
    const tamlar = kucukler.length ? kucukler.map(b => b.dataset.tam) : [anaDugme.dataset.tam];
    let sira = 0;
    const goster = i => {
      sira = (i + tamlar.length) % tamlar.length;
      bfFoto.src = tamlar[sira]; bfFoto.alt = anaFoto.alt;
      if (kucukler[sira]) fotoGoster(kucukler[sira].dataset.medya);
    };
    bf.classList.toggle("tek", tamlar.length < 2);
    anaDugme.addEventListener("click", () => { goster(Math.max(0, tamlar.indexOf(anaDugme.dataset.tam))); bf.showModal(); });
    bf.addEventListener("click", e => {
      const hedef = e.target.closest("[data-bf]")?.dataset.bf;
      if (hedef === "kapat" || e.target === bf || e.target === bfFoto) bf.close();
      else if (hedef) goster(sira + +hedef);
    });
    bf.addEventListener("keydown", e => {
      if (e.key === "ArrowRight") goster(sira + 1);
      if (e.key === "ArrowLeft") goster(sira - 1);
    });
  }

  function yaz() {
    const degerler = varyant.secenekler;
    $("[data-tutar]", kok).textContent = para(varyant.fiyat);
    $("[data-eski]", kok).textContent = varyant.eski > varyant.fiyat ? para(varyant.eski) : "";
    $("[data-birim]", kok).textContent = varyant.adet > 1 ? `${varyant.adet} adet · adet başı ${para(Math.round(birim(varyant)))}` : "";
    const sku = $("[data-sku]", kok);
    if (sku) sku.textContent = varyant.sku ? "SKU: " + varyant.sku : "";

    /* Adet kademeleri: her kademenin fiyatı ve en küçük pakete göre indirimi */
    radyolar.forEach(r => {
      const i = +r.dataset.secenek, etiket = r.closest("label");
      etiket.classList.toggle("secili", r.checked);
      const aday = bul(degerler.map((d, j) => (j === i ? r.value : d)));
      etiket.classList.toggle("tukendi", !aday || !aday.var);
      const fiyatYeri = $("[data-kademe-fiyat]", etiket);
      if (!fiyatYeri) return;
      fiyatYeri.textContent = aday ? para(aday.fiyat) : "—";
      const kardesler = varyantlar.filter(v => v.secenekler.every((d, j) => j === i || d === degerler[j]) && v.adet);
      const taban = kardesler.sort((a, b) => a.adet - b.adet)[0];
      const ind = aday && taban && aday.adet ? Math.round((1 - birim(aday) / birim(taban)) * 100) : 0;
      $("[data-kademe-indirim]", etiket).textContent = ind > 0 ? `${yuzde(ind)} daha ucuz` : "";
    });

    idInput.value = varyant.id;
    ekle.disabled = !varyant.var;
    ekle.textContent = varyant.var ? "Sepete ekle" : "Stokta yok";
    if (varyant.medya) fotoGoster(varyant.medya);
    kok.dispatchEvent(new CustomEvent("varyant", { bubbles: true, detail: { varyant, adet: +adetInput.value || 1 } }));
  }

  radyolar.forEach(r => r.addEventListener("change", () => {
    const v = bul(seciliDegerler());
    if (!v) return;
    varyant = v;
    const url = new URL(location.href);
    url.searchParams.set("variant", v.id);
    history.replaceState(null, "", url);
    yaz();
  }));
  adetInput?.addEventListener("change", () => kok.dispatchEvent(new CustomEvent("varyant", { bubbles: true, detail: { varyant, adet: +adetInput.value || 1 } })));

  form.addEventListener("submit", async e => {
    e.preventDefault();
    const yazi = ekle.textContent;
    ekle.disabled = true; ekle.textContent = "Ekleniyor…";
    try {
      await sepeteEkle([{ id: varyant.id, quantity: +adetInput.value || 1 }]);
      bildir("Sepete eklendi", true);
    } catch (hata) {
      bildir(hata.message);
    } finally {
      ekle.disabled = !varyant.var; ekle.textContent = yazi;
    }
  });

  yaz();
  kok._varyant = () => ({ varyant, adet: +adetInput.value || 1 });
});

/* Birlikte tercih edilenler */
$$("[data-paket]").forEach(async kok => {
  if (kok.dataset.oneriUrl) {
    const html = await fetch(kok.dataset.oneriUrl).then(r => r.text()).catch(() => "");
    const yeni = new DOMParser().parseFromString(html, "text/html").querySelector("[data-paket]");
    if (!yeni || !yeni.children.length) { kok.remove(); return; }
    kok.innerHTML = yeni.innerHTML;
  }
  if (!$("[data-paket-liste]", kok)) { kok.remove(); return; }
  const urun = $("[data-urun]");
  const ekler = $$("[data-ek-id]", kok);
  const liste = $("[data-paket-liste]", kok), toplam = $("[data-paket-toplam]", kok);
  const ana = () => (urun?._varyant ? urun._varyant() : null);

  function yaz() {
    const a = ana();
    const satirlar = [];
    if (a) satirlar.push([`${a.adet > 1 ? a.adet + " × " : ""}${a.varyant.secenekler.join(" · ").replace("Default Title", "Bu ürün")}`, a.varyant.fiyat * a.adet]);
    ekler.filter(x => x.checked).forEach(x => satirlar.push([x.dataset.ekAd, +x.dataset.ekFiyat]));
    liste.innerHTML = "";
    satirlar.forEach(([ad, f]) => {
      const li = document.createElement("li");
      li.innerHTML = "<span></span><b></b>";
      li.firstChild.textContent = ad; li.lastChild.textContent = para(f);
      liste.append(li);
    });
    toplam.textContent = para(satirlar.reduce((t, [, f]) => t + f, 0));
  }
  ekler.forEach(x => x.addEventListener("change", yaz));
  document.addEventListener("varyant", yaz);
  yaz();

  $("[data-paket-ekle]", kok).addEventListener("click", async e => {
    const a = ana(), b = e.currentTarget;
    const kalemler = [...(a && a.varyant.var ? [{ id: a.varyant.id, quantity: a.adet }] : []), ...ekler.filter(x => x.checked).map(x => ({ id: +x.dataset.ekId, quantity: 1 }))];
    if (!kalemler.length) return;
    b.disabled = true;
    try { await sepeteEkle(kalemler); bildir("Paket sepete eklendi", true); }
    catch (hata) { bildir(hata.message); }
    finally { b.disabled = false; }
  });
});
